namespace RioERP.Carts {
    export interface CounterProductsProps {
        item: CounterProductsRow;
        editItem: (item: CounterProductsRow) => void;
    }

    export class CounterProductsCard extends React.Component<CounterProductsProps>
    {
        render(): React.ReactNode
        {
            const item = this.props.item;

            return (


                <table className="customer-card">
                    <tbody>
                        <tr>
                            <td rowSpan={4} className="img">
                                <img
                                    src={item.Thumbnail
                                        ? Q.resolveUrl("~/upload/" + item.Thumbnail)
                                        : "/Content/site/images/serenity-logo-40.png"}
                                    alt="Product Thumbnail"
                                    style={{ width: 100, height: 100, objectFit: "cover", borderRadius: "8px" }}
                                />

                            </td>
                        </tr>
                        <tr>
                            <td className="name">
                                <a href="javascript:;" onClick={() => this.props.editItem(item)}>
                                    <b> {item.ProductName}</b>
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td >{item.TeacherName}</td>
                        </tr>
                        <tr>
                            <td>{item.GrossAmount}</td>
                        </tr>
                        <div style={{

                            display: 'flex',
                            gap: '8px',
                            marginTop: '4px',
                            padding: '2px 8px',
                            alignItems: 'center'
                        }}>
                            <button
                                className="btn btn-sm btn-primary"
                                style={{ whiteSpace: 'nowrap' }}
                                onClick={() => this.addToCart()}
                            >
                                Add to Cart
                            </button>

                            {/*<button className="btn btn-sm btn-success" style={{ whiteSpace: 'nowrap' }}*/}
                            {/*    onClick={() => window.open(item.WebsiteUrl, '_blank')}*/}
                            {/*>*/}
                            {/*    Buy Now*/}
                            {/*</button>*/}
                            <button className="btn btn-sm btn-info" style={{ whiteSpace: 'nowrap' }} onClick={() => this.ViewProduct()}>
                                View Product
                            </button>
                        </div>



                    </tbody>
                </table>
            );
        } 
        addToCart() {
            const item = this.props.item;
            const franchiseeId = item.InsertUserId;
            Q.serviceRequest('Carts/CartProducts/AddToCart', {
                FranchiseeId: item.InsertUserId,
                ProductId: item.Id,
                Quantity: 1
            }, response => {
                Q.notifySuccess("Cart ready. Opening dialog...");

                // Extract CartId from response
                const cartId = response.CustomData?.CartId;
                const productId = response.CustomData?.ProductId;
                if (cartId) {

                    this.OpenCartProductDialog(cartId, productId);
                }
            }, {
                onError: err => {
                    Q.notifyError("Error adding to cart: " );
                }
            });
        }

        ViewProduct() {
            const item = this.props.item;
            const franchiseeId = item.InsertUserId;
            const dlg = new RioERP.Carts.CounterProductsDialog();

            dlg.loadByIdAndOpenDialog(item.Id);
        }


        private OpenCartProductDialog(cartId: number, productId: number) {
            const dlg = new RioERP.Carts.CartProductsDialog();

            dlg.loadEntityAndOpenDialog({
                CartId: cartId,
                ProductId: productId
              
            });
        }

       
    }


}
